var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,3.06A12.94,12.94,0,1,0,28.94,16,12.95,12.95,0,0,0,16,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.51,9.23h-.12V8.41a.59.59,0,1,0-1.18,0v.82H13.72V8.41a.6.6,0,1,0-1.19,0v.82h-.12a3.21,3.21,0,0,0-3.19,3.2V20a3.21,3.21,0,0,0,3.19,3.2h7.1a3.22,3.22,0,0,0,3.2-3.2V12.43A3.22,3.22,0,0,0,19.51,9.23Zm-7.1,1.19h.12v.83a.6.6,0,0,0,1.19,0v-.83h4.49v.83a.59.59,0,1,0,1.18,0v-.83h.12a2,2,0,0,1,2,2V13H10.4v-.59A2,2,0,0,1,12.41,10.42ZM19.51,22h-7.1a2,2,0,0,1-2-2V14.2H21.52V20A2,2,0,0,1,19.51,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.51,16.33h-7.1a.6.6,0,0,0,0,1.19h7.1a.6.6,0,0,0,0-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.33,18.7H13.6a.59.59,0,0,0,0,1.18h4.73a.59.59,0,0,0,0-1.18Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.edb90f1a22f109e9ce4d1ef75cbee383.svg";
export { ForwardRef as ReactComponent };